import { render, staticRenderFns } from "./StatsMarginRateCard.vue?vue&type=template&id=3a75cf18&scoped=true"
import script from "./StatsMarginRateCard.vue?vue&type=script&lang=js"
export * from "./StatsMarginRateCard.vue?vue&type=script&lang=js"
import style0 from "./StatsMarginRateCard.vue?vue&type=style&index=0&id=3a75cf18&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a75cf18",
  null
  
)

export default component.exports